module.exports = __webpack_public_path__ + "img/icon215.8fd3fb9f.png";